/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/boxes/', params);
}

function syncExcel(params) {
  return api.get('/boxes-sync/', params);
}

function create(params) {
  return api.post('/boxes', params);
}

export const boxService = {
  index,
  create,
  syncExcel,
};
